import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import { FaRegLightbulb, FaSearch, FaHandshake, FaHome } from 'react-icons/fa';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './AreaListing.css';
import processCardMask from '../assets/images/process-card1-mask.png';  

// Import images
import Bhongir from '../assets/images/Bhongir.webp';
import Shadnagar from '../assets/images/Shadnagar.webp';
import Vikarabad from '../assets/images/Vikarabad.webp';
import Medchal from '../assets/images/Medchal.webp';
import Zaheerabad from '../assets/images/Zaheerabad.webp';

const AreaListings = () => {
    const sliderRef = React.useRef(null);

    const locations = [
        { name: 'Bhongir', count: '24 Properties', image: Bhongir },
        { name: 'Shadnagar', count: '18 Properties', image: Shadnagar },
        { name: 'Vikarabad', count: '12 Properties', image: Vikarabad },
        { name: 'Medchal', count: '32 Properties', image: Medchal },
        { name: 'Zaheerabad', count: '15 Properties', image: Zaheerabad },
    ];

    const steps = [
        {
            icon: <FaRegLightbulb size={40} />,
            title: "Concept & Planning",
            description: "We develop the perfect concept and strategic plan for your industrial needs"
        },
        {
            icon: <FaSearch size={40} />,
            title: "Design & Research",
            description: "Our team creates optimized designs through thorough research"
        },
        {
            icon: <FaHandshake size={40} />,
            title: "Contract & Deal",
            description: "We establish clear agreements and contracts for the project"
        },
        {
            icon: <FaHome size={40} />,
            title: "Execution & Delivery",
            description: "Final implementation and handover of the completed project"
        }
    ];


    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false, // Disable default arrows
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <>
            <Container className="area-listings-section">
                <Row>
                    <Col className="text-center mb-5">
                        <h2 className="section-title">Find Listings in Your Area</h2>
                        <p className="section-subtitle">Discover properties in popular locations</p>
                    </Col>
                </Row>

                <Row className="justify-content-center">
                    <Col xs={12} md={10} lg={10}>
                        <Slider ref={sliderRef} {...settings} className="location-slider">
                            {locations.map((location, index) => (
                                <div key={index} className="location-card px-2">
                                    <div
                                        className="location-image mx-auto"
                                        style={{
                                            backgroundImage: `url(${location.image})`,
                                            width: '85%'
                                        }}
                                    >
                                        <div className="location-overlay"></div>
                                        <div className="location-content">
                                            <h3>{location.name}</h3>
                                            <p>{location.count}</p>
                                            <button className="explore-btn">
                                                Explore <FaChevronRight />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>

                        {/* Custom navigation buttons below the slider */}
                        <div className="slider-nav-buttons text-center mt-4">
                            <Button
                                variant=""
                                className="mr-3"
                                onClick={() => sliderRef.current.slickPrev()}
                            >
                                <FaChevronLeft />
                            </Button>
                            <Button
                                variant=""
                                onClick={() => sliderRef.current.slickNext()}
                            >
                                <FaChevronRight />
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
           {/* <div className="agent-container" style={{ 
      backgroundImage: `url(${processCardMask})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }}>
      <div className="agent-box">
        <div className="agent-number">01</div>
        <div className="agent-content">
          <h3 className="agent-title">Meet Our Agent</h3>
          <p className="agent-description">
            Proactively envisioned multimedia based expertise cross-media growth
          </p>
        </div>
      </div>
    </div> */}

        </>
    );
};

export default AreaListings;